export default "__VITE_ASSET__9df3475d__"